import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Form, Icon, Row, Select, Table, Modal, Popconfirm } from 'antd';
import _ from 'lodash';

import * as customerController from '../../../../../../services/api/customer';
import './CustomerList.scss';

const TABLE_PAGESIZE = process.env.TABLE_PAGESIZE;

const FormItem = Form.Item;
const Option = Select.Option;

export class CustomerList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            filteredDataSource: [],
            selectedRowKeys: [],
            mergeModalVisible: false,
            customerConsultantPairs: [],
            mergeTarget: undefined,
            pagination: {
                pageSize: parseInt(TABLE_PAGESIZE, 10)
            },
            sorter: {},
            searchText: undefined,
            isLoading: false
        }
    }

    filterData() {
        const { searchText } = this.props;
        const { pagination } = this.state;

        this.setState({ pagination: { ...pagination, current: 1 }, searchText });
    }

    fetchData() {
        const { pagination, sorter, searchText } = this.state;
        let query = {
            limit: pagination.pageSize,
            page: pagination.current,
            sort_field: sorter.field,
            sort_order: sorter.order,
            search: searchText,
        };

        this.setState({ isLoading: true });

        customerController.getCustomers(query)
            .then((res) => res.json())
            .then((json) => {
                this.setState({ dataSource: json.result, pagination: { ...this.state.pagination, total: json.count }, isLoading: false })
            })
            .catch((err) => console.log(err))
    }

    fetchCustomerConsultantPairs() {
        const { selectedRowKeys } = this.state;

        customerController.getCustomersLatestConsultant(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.setState({ customerConsultantPairs: json.result })
            })
            .catch((err) => console.log(err))
    }

    handleTableChange(pagination, tableFilters, sorter) {
        this.setState({
            pagination,
            sorter
        });
    }

    handleMerge() {
        const { selectedRowKeys, mergeTarget } = this.state;

        this.setState({ isLoading: true });

        customerController.mergeCustomers(_.pull(selectedRowKeys, mergeTarget), mergeTarget)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
                this.setState({ mergeModalVisible: false, selectedRowKeys: [], mergeTarget: undefined })
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;

        this.setState({ isLoading: true });

        customerController.deleteCustomers(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        const { isActive } = this.props;
        const { mergeModalVisible, pagination, sorter, searchText } = this.state;

        if (this.props.searchText !== prevProps.searchText) {
            this.filterData();
        }

        if ((isActive && isActive !== prevProps.isActive) || searchText !== prevState.searchText || !_.isEqual(pagination, prevState.pagination) || !_.isEqual(sorter, prevState.sorter)) {
            this.fetchData();
        }

        if (mergeModalVisible !== prevState.mergeModalVisible && mergeModalVisible) {
            this.fetchCustomerConsultantPairs();
        }
    }

    renderExpandedTable(record) {
        const { email2, contact_number2, gender, qualification, work_experience, remarks, is_locked, number_of_current_lead, number_of_enrolled_lead, number_of_blacklisted_lead, number_of_lead } = record;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Form className="ExpandedTableForm">
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Email 2">
                            <span>{email2}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Contact Number 2">
                            <span>{contact_number2}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Gender">
                            <span>{gender}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Locked">
                            <span>{is_locked ? 'Yes' : 'No'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Qualification">
                            <span>{qualification}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Work Experience">
                            <span>{work_experience}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="Remarks">
                            <span>{remarks}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Current Lead">
                            <span>{number_of_current_lead}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Enrolled Lead">
                            <span>{number_of_enrolled_lead}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Blacklisted Lead">
                            <span>{number_of_blacklisted_lead}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Total Lead">
                            <span>{number_of_lead}</span>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }
    render() {
        const { history } = this.props;
        const { dataSource, selectedRowKeys, mergeModalVisible, customerConsultantPairs, mergeTarget, pagination, isLoading } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;
        const isMultiRowSelected = selectedRowKeys.length > 1;
        const mergeOptions = _.map(selectedRowKeys, id => {
            const targetCustomer = _.find(dataSource, { id });
            const targetPair = _.find(customerConsultantPairs, { customer_id: id }) || {};

            if (!_.isEmpty(targetCustomer))
                return (
                    <Option key={id} value={id}>
                        {`(id: ${targetCustomer.id}) ${targetCustomer.name} [${targetCustomer.email ? targetCustomer.email : 'N/A'}, ${targetCustomer.contact_number ? targetCustomer.contact_number : 'N/A'}] - Total Lead: ${targetCustomer.number_of_lead}, handled by ${targetPair.name || 'N/A'}`}
                    </Option>
                );
        });

        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: true
        }, {
            title: 'Contact Number',
            dataIndex: 'contact_number',
            key: 'contact_number',
            sorter: true
        }, {
            title: 'Company Name',
            dataIndex: 'company_name',
            key: 'company_name',
            sorter: true
        }, {
            title: 'Occupation',
            dataIndex: 'occupation',
            key: 'occupation',
            sorter: true
        }, {
            title: 'i-Points',
            dataIndex: 'ipoints',
            key: 'ipoints',
            align: 'center',
            sorter: true
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/admin/customer/${record.id}`)} />)
        }];

        return (
            <div className="CustomerList DataList">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => history.push('/dashboard/admin/customer/new')}>
                            <Icon type="plus"/>
                            Create
                        </button>
                        <button disabled={!isMultiRowSelected} onClick={(e) => this.setState({ mergeModalVisible: true })}>
                            <Icon type="shrink" />
                            Merge
                        </button>
                    </div>
                    <div className="table-btn-gp-right">
                        <Popconfirm 
                            placement="bottom"
                            title="This action is irreversible, are you sure?" 
                            onConfirm={(e) => this.handleRemove()} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <button disabled={!isRowSelected}>
                                <Icon type="minus"/>
                                Remove
                            </button>
                        </Popconfirm>
                    </div>
                </div>
                <Table
                    loading={isLoading}
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
                    rowClassName={(record, string) => record.is_locked ? 'locked' : ''}
                    expandedRowRender={(record) => this.renderExpandedTable(record)}
                    pagination={pagination}
                    onChange={(pagination, filters, sorter) => this.handleTableChange(pagination, filters, sorter)}
                />
                <Modal
                    className="MergeModal"
                    visible={mergeModalVisible}
                    footer={null}
                    onCancel={(e) => this.setState({ mergeModalVisible: false, mergeTarget: undefined })}
                >
                    <p>Select a customer that you want to keep, others will be removed.</p>
                    <Select
                        dropdownMatchSelectWidth={false}
                        style={{ width: '100%' }}
                        value={mergeTarget}
                        onSelect={(value) => this.setState({ mergeTarget: value })}
                    >
                        {mergeOptions}
                    </Select>
                    <Button type="primary" disabled={_.isUndefined(mergeTarget)} onClick={(e) => this.handleMerge(e)}>Merge</Button>
                </Modal>
            </div>
        );
    }
}

export default withRouter(CustomerList);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerPage/components/CustomerList/CustomerList.js